// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32w81","colBig":"styles_colBig__30myL","colSmall":"styles_colSmall__2NiVO"};